export const CableSpoolingStorageTypeEnum = {
  addToStorageReel: { value: 0, label: 'Add to Storage Reel' },
  addToSpecificDrum: { value: 1, label: 'Add to Specific Drum' },
};
